import React from 'react';
import { Box, Typography } from '@mui/material';
import { GangListItem } from '../molecules/GangListItem';
import { ListViewShell } from '../../../../shared/components/ui/ListViewShell';

type GangMember = {
  userId: string;
  givenName?: string | null;
  familyName?: string | null;
  isLeader: boolean;
};

export interface GangItem {
  id: string;
  name: string;
  members: GangMember[];
}

export interface GangsListViewProps {
  gangs: GangItem[];
  loading: boolean;
  onRowClick?: (id: string) => void;
}

export const GangsListView: React.FC<GangsListViewProps> = ({
  gangs,
  loading,
  onRowClick,
}) => {
  return (
    <ListViewShell
      itemCount={gangs.length}
      loading={loading}
      emptyMessage="No gangs found"
      data-testid="gangs-table"
      columnHeaders={
        <>
          <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>
            Name
          </Typography>
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <Typography variant="caption" color="text.secondary">
              Members
            </Typography>
          </Box>
        </>
      }
    >
      {gangs.map(gang => (
        <GangListItem
          key={gang.id}
          id={gang.id}
          name={gang.name}
          members={gang.members}
          onRowClick={onRowClick}
        />
      ))}
    </ListViewShell>
  );
};
